const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * User Password Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('Passcode', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {

  return $resource(appConfiguration.apiUrl + '/v3/password/:resource/:subresource', null, {
    request: {params: {resource: 'request', subresource: ''}, method: 'POST'},
    reset: {params: {resource: 'reset', subresource: ''}, method: 'POST'},
    update: {params: {resource: 'users', subresource: ''}, method: 'POST'}
  });

}]);
